import { render, staticRenderFns } from "./getWebinars.vue?vue&type=template&id=4cbcee8e&scoped=true"
import script from "./getWebinars.vue?vue&type=script&lang=js"
export * from "./getWebinars.vue?vue&type=script&lang=js"
import style0 from "./getWebinars.vue?vue&type=style&index=0&id=4cbcee8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbcee8e",
  null
  
)

export default component.exports